import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { Vault } from '../models/vault';
import { shelRoomInitialState, shelfRack, shelfRoom } from './../models/shelfRack';
import { store } from './store';

export default class ShelfRackStore {
  shelfRackRegistry = new Map<string, shelfRack>();
  selectedshelfRack: shelfRack | undefined = undefined;
  loadingInitial = false;
  shelfRoomDetails:shelfRoom[] =[shelRoomInitialState]
  loading = false;
  constructor() {
    makeAutoObservable(this);
  }
  get shelfRackitemsByDate() {
    return Array.from(this.shelfRackRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setshelfRack = (shelfRack: shelfRack) => {
    this.shelfRackRegistry.set(shelfRack.id, shelfRack);
  };

  private getshelfRack = (id: string) => {
    return this.shelfRackRegistry.get(id);
  };

  loadshelfRacks = async () => {
    this.loadingInitial = true;
    try {
      const shelfRackDetails = await agent.ShelfRack.list();
      // console.log(recievingdelivery);
      shelfRackDetails.forEach((shelfRackDetails) => {
        runInAction(() => {
          this.setshelfRack(shelfRackDetails);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  HFCloadshelfRacks= async () => {
    this.loadingInitial = true;
    try {
      const RoomDetails:any = await agent.ShelfRack.HFClist();
        runInAction(() => {
          this.shelfRoomDetails = RoomDetails.data
        });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  }

  loadshelfRack = async (id: string) => {
    this.loadingInitial = true;
    try {
      const shelfRackDetail = await agent.ShelfRack.details(id);
      this.setshelfRack(shelfRackDetail);
      runInAction(() => {
        this.selectedshelfRack = shelfRackDetail;
      });
      this.setLoadingInitial(false);
      return shelfRackDetail;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  createShelfRack = async (shelfRack: Vault) => {
    try {
      await agent.Vaults.UpdateShelf(shelfRack);
      runInAction(() => {
        store.vaultStore.vaultRegistry.set(shelfRack.id, shelfRack);
      });
      toast.success('Shelf/Rack  Record Created Successfully ');
    } catch (error) {
      console.log(error);
    }
  };
  updateShelfRack = async (shelfRack: shelfRack) => {
    this.loading = true;
    try {
      await agent.ShelfRack.update(shelfRack);
      runInAction(() => {
        this.shelfRackRegistry.set(shelfRack.id, shelfRack);
        this.selectedshelfRack = shelfRack;
        // this.editMode = false;
        this.loading = false;
      });
      toast.success('Shelf/Rack Updated Succesfully.');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  deleteShelfRack = async (shelfRack: shelfRack) => {
    try {
      await agent.ShelfRack.delete(shelfRack);
      runInAction(() => {
        this.shelfRackRegistry.delete(shelfRack.id);
      });
      toast.success('Shelf/Rack Deleted Succesfully.');
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };
}
